module.exports = __webpack_public_path__ + "img/Weapon_297.5738223c.png";